<nav class="navbar pt-0 navbar-expand-lg navbar-default bg-default navbar-static-side" role="navigation">
  <div class="sidebar-collapse">
    <ul class="nav metismenu" id="side-menu">
      <li class="nav-header full-width">
        <div class="profile-element">
          <span class="menu-item-skeleton pulse app-user-pic img-circle"> </span>
          <div>
            <span class="name-role-skeleton pulse block m-t-xs"></span>
            <span class="name-role-skeleton pulse block m-t-xs"></span>
          </div>
        </div>
      </li>
      <li class="full-width nav-items-style block">
        <ng-container *ngFor="let item of [].constructor(navbarItems)">
          <span class="menu-item-skeleton pulse block menu-item-style"></span>
        </ng-container>
      </li>
    </ul>
  </div>
</nav>
